import TicketDeskStore from "./TicketDeskStore";
import TicketAttachmentsStore from "./TicketAttachmentsStore";
import SupportMailStore from "./SupportMail/SupportMailStore";

// `ticketDeskStore`, not `ticketsStore`: that key belongs to the `tickets`
// ServiceStore, and a colliding app store would silently drop it.
//
// ORDER MATTERS: `ticketAttachmentsStore` follows the drawer through a reaction
// on `ticketDeskStore.selected`, and `rootStore.ticketDeskStore` is a plain
// (non-observable) property — it has to be mounted before the reaction is armed.
const ticketsStoreList = [
  { name: "ticketDeskStore", store: TicketDeskStore },
  { name: "ticketAttachmentsStore", store: TicketAttachmentsStore },
  // Unmatched support mail (Tickets → Unmatched support mail). Reads the desk's
  // client list, so it follows the desk.
  { name: "supportMailStore", store: SupportMailStore },
];

export default ticketsStoreList;
